<template>
  <div class="m-5 xl:m-15 2xl:m-20">
    <!-- BEGIN Popup compare cartography -->
    <PopupCompareCarto
      :compare-carto="compareCarto"
      @close="closeCompare"
      @changeCompare="
        (index) => {
          changeCompare(index);
        }
      "
      :carto-to-compare="cartoToCompare"
      :history-to-display="historyToDisplay"
      :competences-cles="cartoCompetencesClesToDisplay"
      :history-competences-cles="allowedCompCleHistories"
      :competences-informatique="cartoInformatiqueToDisplay"
      :history-competences-informatique="allowedCompInfoHistories"
      :competences-linguistique="cartoLangueToDisplay"
      :history-competences-linguistique="allowedLangHistories"
      :competences-socio-pro="{}"
      :history-competences-socio-pro="{}"
      :competences-pro="{}"
      :history-competences-pro="{}"
      v-if="compareCarto"
    />
    <!-- END Popup compare cartography -->

    <div
      v-if="
        Object.keys(competencesCles || {}).length > 0 ||
          historyCompetencesCles.length > 0 ||
          Object.keys(competencesInformatique || {}).length > 0 ||
          historyCompetencesInformatique.length > 0 ||
          Object.keys(competencesLinguistique || {}).length > 0 ||
          historyCompetencesLinguistique.length > 0
      "
    >
      <h3 class="mb-10">
        Compétences personnelles
      </h3>

      <div v-if="toReload">
        <div class="w-full">
          <!-- BEGIN Compétences clés -->
          <div v-if="cartoCompetencesClesToDisplay">
            <!-- BEGIN List modèles de pages -->
            <div class="flex justify-center items-center">
              <div
                class="flex relative cursor-pointer my-8 w-max max-w-7/12"
                @click.stop="
                  displayTemplateList(
                    constants.PAGE_NEOPASS_FORM_COMPETENCES_CLES
                  )
                "
              >
                <div class="flex flex-row ml-auto items-end">
                  <div class="text-indigo-600 font-normal text-xl">
                    {{
                      listTemplates.compcle[
                        currentTemplate.compcle
                      ].toUpperCase()
                    }}
                  </div>
                </div>
                <div
                  class="text-pink-600 max-h-8 rounded-full relative flex items-center p-2 order-2"
                >
                  <icon
                    class="h-4 w-4"
                    name="chevron-down"
                  />
                </div>
                <div
                  class="fieldlist flex z-20 mt-2 top-10 w-max max-w-full right-0 absolute rounded-md bg-white shadow-md shadow-gray-600 text-sm"
                  v-if="
                    templateListDisplayed ==
                      constants.PAGE_NEOPASS_FORM_COMPETENCES_CLES
                  "
                  v-click-outside="closeTemplateList"
                  id="compcle"
                >
                  <div class="mx-5 my-3">
                    <div class="text-left">
                      <div
                        class="first:pt-2 py-1"
                        v-for="(tmp, i) in listTemplates.compcle"
                        :key="i"
                      >
                        <p
                          class="text-gray-600 hover:text-gray-900"
                          @click.stop="
                            changeTemplate(
                              constants.PAGE_NEOPASS_FORM_COMPETENCES_CLES,
                              i
                            )
                          "
                        >
                          <span>{{ tmp }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- END List modèles de pages -->

            <div
              v-if="cartoCompetencesClesToDisplay"
              class="mb-10"
            >
              <div v-if="cartoCompetencesClesToDisplay.type == 'multi3'">
                <radar
                  id-chart="compcle"
                  :labels="cartoCompetencesClesToDisplay.labels"
                  :values="cartoCompetencesClesToDisplay.values"
                  :max="cartoCompetencesClesToDisplay.max"
                  height="150"
                />
              </div>
              <div v-else-if="cartoCompetencesClesToDisplay.type == 'clea'">
                <pie
                  id-chart="compcle"
                  title=""
                  :labels="cartoCompetencesClesToDisplay.longLabels"
                  :values="cartoCompetencesClesToDisplay.datas"
                  :colors="cartoCompetencesClesToDisplay.colors"
                  position-legend="bottom"
                  height="400"
                />
              </div>
              <div
                v-if="
                  $can(constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE)
                "
                class="mt-8 w-full text-center flex justify-center"
              >
                <action-button
                  class="py-2"
                  border-color="transparent"
                  text-color="text-white"
                  bg-color="bg-pink-600"
                  libelle="Comparer"
                  :is-disabled="cantCompareCles"
                  :enable-action="canCompareCles"
                  disabled-tooltip="Pour profiter de cette fonctionnalité, veuillez faire une deuxième évaluation pour les comparer."
                  @clickAction="
                    displayCompareCarto(
                      constants.PAGE_NEOPASS_FORM_COMPETENCES_CLES
                    )
                  "
                />
              </div>
            </div>
            <!-- END Compétences clés -->
          </div>

          <!-- BEGIN Compétences informatique -->
          <div v-if="cartoInformatiqueToDisplay">
            <!-- BEGIN List modèles de pages -->
            <div class="flex justify-center items-center">
              <div
                class="flex relative cursor-pointer my-8 w-max max-w-7/12"
                @click.stop="
                  displayTemplateList(
                    constants.PAGE_NEOPASS_FORM_NIVEAU_INFORMATIQUE
                  )
                "
              >
                <div class="flex flex-row ml-auto items-end">
                  <div class="text-indigo-600 font-normal text-xl">
                    {{
                      listTemplates.informatique[
                        currentTemplate.informatique
                      ].toUpperCase()
                    }}
                  </div>
                </div>
                <div
                  class="text-pink-600 max-h-8 rounded-full relative flex items-center p-2 order-2"
                >
                  <icon
                    class="h-4 w-4"
                    name="chevron-down"
                  />
                </div>
                <div
                  class="fieldlist flex z-20 mt-2 top-10 w-max max-w-full right-0 absolute rounded-md bg-white shadow-md shadow-gray-600 text-sm"
                  v-if="
                    templateListDisplayed ==
                      constants.PAGE_NEOPASS_FORM_NIVEAU_INFORMATIQUE
                  "
                  v-click-outside="closeTemplateList"
                  id="informatique"
                >
                  <div class="mx-5 my-3">
                    <div class="text-left">
                      <div
                        class="first:pt-2 py-1"
                        v-for="(tmp, i) in listTemplates.informatique"
                        :key="i"
                      >
                        <p
                          class="text-gray-600 hover:text-gray-900"
                          @click.stop="
                            changeTemplate(
                              constants.PAGE_NEOPASS_FORM_NIVEAU_INFORMATIQUE,
                              i
                            )
                          "
                        >
                          <span>{{ tmp }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- END List modèles de pages -->

            <div
              v-if="cartoInformatiqueToDisplay"
              class="mb-15"
            >
              <div v-if="cartoInformatiqueToDisplay.type == 'multi3'">
                <radar
                  id-chart="informatique"
                  :labels="cartoInformatiqueToDisplay.labels"
                  :values="cartoInformatiqueToDisplay.values"
                  :max="cartoInformatiqueToDisplay.max"
                  height="150"
                />
              </div>
              <div
                v-else-if="
                  ['clea_num', 'ref_clea_num'].includes(
                    cartoInformatiqueToDisplay.type
                  )
                "
              >
                <pie
                  id-chart="informatique"
                  title=""
                  :labels="cartoInformatiqueToDisplay.longLabels"
                  :values="cartoInformatiqueToDisplay.datas"
                  :colors="cartoInformatiqueToDisplay.colors"
                  position-legend="bottom"
                  height="400"
                />
              </div>
              <div
                class="mt-8 w-full text-center flex justify-center"
                v-if="
                  $can(constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE)
                "
              >
                <action-button
                  class="py-2"
                  border-color="transparent"
                  text-color="text-white"
                  bg-color="bg-pink-600"
                  libelle="Comparer"
                  :is-disabled="cantCompareInformatique"
                  :enable-action="canCompareInformatique"
                  disabled-tooltip="Pour profiter de cette fonctionnalité, veuillez faire une deuxième évaluation pour les comparer."
                  @clickAction="displayCompareCarto('informatique')"
                />
              </div>
            </div>
          </div>
          <!-- END Compétences informatique -->

          <!-- BEGIN Compétences linguistique -->
          <div
            v-if="
              Object.values(cartoLangueToDisplay).length > 0 &&
                cartoLangueToDisplay
            "
            class="mb-15"
          >
            <!-- BEGIN List modèles de pages -->
            <div class="flex justify-center items-center">
              <div
                class="flex relative cursor-pointer my-8 w-max max-w-7/12"
                @click.stop="displayTemplateList('langue')"
              >
                <div class="flex flex-row ml-auto items-end">
                  <div class="text-indigo-600 font-normal text-xl">
                    {{
                      listTemplates.langue[currentTemplate.langue].toUpperCase()
                    }}
                  </div>
                </div>
                <div
                  class="text-pink-600 max-h-8 rounded-full relative flex items-center p-2 order-2"
                >
                  <icon
                    class="h-4 w-4"
                    name="chevron-down"
                  />
                </div>
                <div
                  class="fieldlist flex z-20 mt-2 top-10 w-max max-w-full right-0 absolute rounded-md bg-white shadow-md shadow-gray-600 text-sm"
                  v-if="templateListDisplayed == 'langue'"
                  v-click-outside="closeTemplateList"
                  id="langue"
                >
                  <div class="mx-5 my-3">
                    <div class="text-left">
                      <div
                        class="first:pt-2 py-1"
                        v-for="(tmp, i) in listTemplates.langue"
                        :key="i"
                      >
                        <p
                          class="text-gray-600 hover:text-gray-900"
                          @click.stop="changeTemplate('langue', i)"
                        >
                          <span>{{ tmp }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- END List modèles de pages -->

            <!-- Case there is a current evaluation -->
            <div v-if="cartoLangueToDisplay">
              <div
                v-for="(langue, index) in cartoLangueToDisplay"
                :key="index"
                class="mb-10"
              >
                <radar
                  v-if="currentTemplate.langue >= 0"
                  :id-chart="'langue' + index"
                  :title="langue.values.title"
                  :labels="langue.labels"
                  :values="langue.values.value"
                  :max="langue.max"
                />
                <div
                  class="mt-8 w-full text-center flex justify-center"
                  v-if="
                    $can(constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_COMPARE)
                  "
                >
                  <action-button
                    class="py-2"
                    border-color="transparent"
                    text-color="text-white"
                    bg-color="bg-pink-600"
                    libelle="Comparer"
                    :is-disabled="cantCompareLinguistique"
                    :enable-action="canCompareLinguistique"
                    disabled-tooltip="Pour profiter de cette fonctionnalité, veuillez faire une deuxième évaluation pour les comparer."
                    @clickAction="
                      displayCompareCarto(
                        'linguistique/' + index + '/' + langue.values.title
                      )
                    "
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- END Compétences linguistique -->
        </div>
      </div>
    </div>

    <div
      v-else
      class="flex flex-col justify-center items-center w-full"
    >
      <h6 class="text-pink-600 w-full mb-8">
        Aucune donnée
      </h6>
      <div class="text-indigo-600 text-center text-base mb-8">
        {{ infosPass.name }} n'a pas d'évaluation de compétences personnelles
      </div>
      <div>
        <illustration name="no_result" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Icon from '../../../components/Icon';
import ActionButton from '../../../components/ActionButton';
import Radar from '../../../components/Charts/Radar';
import Pie from '../../../components/Charts/Pie';
import Illustration from '../../../components/Illustration';
import PopupCompareCarto from '../../../components/Cartographies/PopupCompareCarto';
import ClickOutside from 'vue-click-outside';
import Constants from './../../../constants';

export default {
  components: {
    PopupCompareCarto,
    Icon,
    ActionButton,
    Radar,
    Illustration,
    Pie,
  },

  name: 'Compperso',

  data() {
    return {
      colors: {
        type: 'normal',
        beneficiary: '#21B8C8',
        referent: '#FF1C80',
        true: '#21B8C85A',
        false: '#919AA65A',
      },
      compareCarto: false,
      cartoToCompare: '',
      historyToDisplay: -1,
      toReload: true, //use to hide and show cartography and check changes
      currentTemplate: {
        compcle: 0,
        informatique: 0,
        langue: 0,
      },
      templateListDisplayed: '',
      constants: Constants,
    };
  },

  created() {
    this.setLastEvaluationTemplates();
  },

  methods: {
    /**
     * Each evaluation has template which can be different
     * Here, we retrieve the template used in the last evaluation to display the right template name in the template dropdown (for each kind of evaluation)
     */
    setLastEvaluationTemplates() {
      if (Object.keys(this.competencesCles).length > 0) {
        this.currentTemplate.compcle = parseInt(
          Object.keys({ ...this.listTemplates.compcle }).filter(
            (key) =>
              this.listTemplates.compcle[key] ==
              this.competencesCles.template_name
          )[0]
        );
      } else if (this.historyCompetencesCles.length > 0) {
        this.currentTemplate.compcle = parseInt(
          Object.keys({ ...this.listTemplates.compcle }).filter(
            (key) =>
              this.listTemplates.compcle[key] ==
              this.historyCompetencesCles[
                this.historyCompetencesCles.length - 1
              ].template_name
          )[0]
        );
      }

      if (Object.keys(this.competencesInformatique).length > 0) {
        this.currentTemplate.informatique = parseInt(
          Object.keys({ ...this.listTemplates.informatique }).filter(
            (key) =>
              this.listTemplates.informatique[key] ==
              this.competencesInformatique.template_name
          )[0]
        );
      } else if (this.historyCompetencesInformatique.length > 0) {
        this.currentTemplate.informatique = parseInt(
          Object.keys({ ...this.listTemplates.informatique }).filter(
            (key) =>
              this.listTemplates.informatique[key] ==
              this.historyCompetencesInformatique[
                this.historyCompetencesInformatique.length - 1
              ].template_name
          )[0]
        );
      }

      if (Object.keys(this.competencesLinguistique).length > 0) {
        this.currentTemplate.langue = parseInt(
          Object.keys({ ...this.listTemplates.langue }).filter(
            (key) =>
              this.listTemplates.langue[key] ==
              this.competencesLinguistique.template_name
          )[0]
        );
      } else if (
        this.historyCompetencesLinguistique[1] &&
        this.historyCompetencesLinguistique[1].length > 0
      ) {
        this.currentTemplate.langue = parseInt(
          Object.keys({ ...this.listTemplates.langue }).filter(
            (key) =>
              this.listTemplates.langue[key] ==
              this.historyCompetencesLinguistique[1][
                this.historyCompetencesLinguistique.length - 1
              ].template_name
          )[0]
        );
      }
    },

    /**
     * display popup to compare a cartography
     * @param String typeCarto
     */
    displayCompareCarto(typeCarto) {
      this.compareCarto = true;
      this.cartoToCompare = typeCarto;
    },

    /**
     * Close popup to compare cartography
     */
    closeCompare() {
      this.compareCarto = false;
      this.cartoToCompare = '';
      this.historyToDisplay = -1;
    },

    /**
     * Change the history cartography to compare
     * @param Number index
     */
    changeCompare(index) {
      setTimeout(() => {
        this.historyToDisplay = -1;
      }, 300); //RAZ to refresh the canvas
      setTimeout(() => {
        this.historyToDisplay = index;
      }, 300);
    },

    /**
     * /!\ Method not used for the moment
     * User can choose the cartography colors between old (passeport compétences) or new (neopass) colors
     * @param String n
     */
    switchColor(n) {
      switch (n) {
      case 'normal':
        this.colors.beneficiary = '#21B8C8';
        this.colors.referent = '#FF1C80';
        break;
      case 'old':
        this.colors.beneficiary = '#31AFDE';
        this.colors.referent = '#94AC49';
        break;
      default:
        this.colors.beneficiary = '#21B8C8';
        this.colors.referent = '#FF1C80';
        break;
      }
      this.colors.type = n;
      setTimeout(() => {
        this.toReload = false;
      }, 300);
      setTimeout(() => {
        this.toReload = true;
      }, 300);
    },

    /**
     * Display drop down to choose the template by module name
     * @param String module
     */
    displayTemplateList(module) {
      if (this.templateListDisplayed != module && module != '') {
        this.templateListDisplayed = module;
      }
    },

    /**
     * Close the template choice drop down
     */
    closeTemplateList() {
      if (this.templateListDisplayed != '') {
        this.templateListDisplayed = '';
      }
    },

    /**
     * Change the module template to display cartography
     * @param String type
     * @param Number index
     */
    changeTemplate(type, index) {
      setTimeout(() => {
        this.currentTemplate[type] = -1;
      }, 300);
      setTimeout(() => {
        this.currentTemplate[type] = index;
      }, 300);
      this.closeTemplateList();
    },
  },

  computed: {
    ...mapGetters({
      neopassDatas: 'cartographiesIndividuelles/neopassDatas',
      infosPass: 'cartographiesIndividuelles/infosPass',
      listEvaluations: 'cartographiesIndividuelles/listEvaluations',
      infosPage: 'cartographiesIndividuelles/infosPage',
    }),

    competencesCles() {
      return (
        (this.neopassDatas || {})[
          Constants.PAGE_NEOPASS_FORM_COMPETENCES_CLES
        ] || {}
      );
    },

    historyCompetencesCles() {
      return (
        (this.listEvaluations || {})[
          Constants.PAGE_NEOPASS_FORM_COMPETENCES_CLES
        ] || []
      );
    },

    competencesInformatique() {
      return (
        (this.neopassDatas || {})[
          Constants.PAGE_NEOPASS_FORM_NIVEAU_INFORMATIQUE
        ] || {}
      );
    },

    historyCompetencesInformatique() {
      return (
        (this.listEvaluations || {})[
          Constants.PAGE_NEOPASS_FORM_NIVEAU_INFORMATIQUE
        ] || []
      );
    },

    competencesLinguistique() {
      return (
        (this.neopassDatas || {})[
          Constants.PAGE_NEOPASS_FORM_COMPETENCES_LINGUISTIQUES
        ] || {}
      );
    },

    historyCompetencesLinguistique() {
      return (
        (this.listEvaluations || {})[
          Constants.PAGE_NEOPASS_FORM_COMPETENCES_LINGUISTIQUES
        ] || []
      );
    },

    /**
     * Determine the competences clés evaluation to show between current evaluation and last history
     */
    cartoCompetencesClesToDisplay() {
      if (
        Object.keys(this.competencesCles).length > 0 ||
        this.historyCompetencesCles.length > 0
      ) {
        //Verify there is at least one evaluation
        if (
          Object.keys(this.competencesCles).length > 0 &&
          this.listTemplates.compcle[this.currentTemplate.compcle] ==
            this.competencesCles.template_name
        ) {
          //Verify existing current evaluation and the template is right
          return this.competencesCles;
        } else {
          //else take the last history
          let history = this.historyCompetencesCles.filter(
            (hist) =>
              hist.template_name ==
              this.listTemplates.compcle[this.currentTemplate.compcle]
          );
          return history[history.length - 1];
        }
      } else {
        return null;
      }
    },

    /**
     * Determine the niveau informatique evaluation to show between current evaluation and last history
     */
    cartoInformatiqueToDisplay() {
      if (
        Object.keys(this.competencesInformatique).length > 0 ||
        this.historyCompetencesInformatique.length > 0
      ) {
        //Verify there is at least one evaluation
        if (
          Object.keys(this.competencesInformatique).length > 0 &&
          this.listTemplates.informatique[this.currentTemplate.informatique] ==
            this.competencesInformatique.template_name
        ) {
          //Verify existing current evaluation and the template is right
          return this.competencesInformatique;
        } else {
          //else take the last history
          let history = this.historyCompetencesInformatique.filter(
            (hist) =>
              hist.template_name ==
              this.listTemplates.informatique[this.currentTemplate.informatique]
          );
          return history[history.length - 1];
        }
      } else {
        return null;
      }
    },

    /**
     * Determine the niveau langue evaluation to show between current evaluation and last history
     */
    cartoLangueToDisplay() {
      let langues = {};

      if (
        Object.keys(this.competencesLinguistique).length > 0 &&
        this.listTemplates.langue[this.currentTemplate.langue] ==
          this.competencesLinguistique.template_name
      ) {
        //Verify existing current evaluation and the template is right

        //organize datas evaluation per language
        this.competencesLinguistique.values.forEach((langue) => {
          langues[langue.title] = this.competencesLinguistique;
          langues[langue.title].values = langue;
          langues[langue.title].date_fin_eval = new Date();
        });
      }

      if (((this.historyCompetencesLinguistique || [])[1] || []).length > 0) {
        // take last history evalaution
        let history = this.historyCompetencesLinguistique[1].filter(
          (hist) =>
            hist.template_name ==
            this.listTemplates.langue[this.currentTemplate.langue]
        );

        if (history.length > 0) {
          //organize datas evaluation per language
          history.forEach((hist) => {
            if (
              !langues[hist.langue] ||
              (langues[hist.langue] &&
                hist.date_fin_eval >
                  ((langues || {})[hist.langue] || {}).date_fin_eval)
            )
              langues[hist.langue] = {
                date_fin_eval: hist.date_fin_eval,
                labels: hist.labels,
                max: hist.max,
                template_name:
                  this.listTemplates.langue[this.currentTemplate.langue],
                type: hist.type,
                values: { title: hist.langue, value: [hist.values[0]] },
              };
          });
        }
      }

      return langues;
    },

    /**
     * Retrieve templates by evaluation type
     */
    listTemplates() {
      let list = {
        compcle: [],
        informatique: [],
        langue: [],
      };

      for (const [pageName, data] of Object.entries(this.neopassDatas)) {
        if (list[pageName] && data.template_name) {
          list[pageName].push(data.template_name);
        }
      }

      for (const [pageName, evaluations] of Object.entries(
        this.listEvaluations
      )) {
        if (list[pageName]) {
          switch (pageName) {
          case Constants.PAGE_NEOPASS_FORM_COMPETENCES_LINGUISTIQUES:
            evaluations[1].forEach((evaluation) => {
              if (list[pageName] && evaluation.template_name) {
                list[pageName].push(evaluation.template_name);
              }
            });
            break;

          default:
            evaluations.forEach((evaluation) => {
              if (list[pageName] && evaluation.template_name) {
                list[pageName].push(evaluation.template_name);
              }
            });
            break;
          }
          list[pageName] = list[pageName].filter(function (value, index, self) {
            return self.indexOf(value) === index;
          });
        }
      }

      return list;
    },

    canCompareCles() {
      //TRUE if there are 2 evals in history
      //TRUE if there is 1 eval in history and 1 current eval
      //FALSE otherwise

      //count how many history with the same template
      const evalCount = this.historyCompetencesCles.filter(
        (hist) =>
          hist.template_name ==
          this.listTemplates.compcle[this.currentTemplate.compcle]
      ).length;

      //Verify if current template is the same than the current evaluation
      const hasCurrent =
        this.competencesCles &&
        this.listTemplates.compcle[this.currentTemplate.compcle] ==
          this.competencesCles.template_name &&
        Object.keys(this.competencesCles).length > 0;

      return evalCount >= 2 || (evalCount > 0 && hasCurrent);
    },

    cantCompareCles() {
      return !this.canCompareCles;
    },

    canCompareInformatique() {
      //TRUE if there are 2 evals in history
      //TRUE if there is 1 eval in history and 1 current eval
      //FALSE otherwise

      //count how many history with the same template
      const evalCount =
        this.historyCompetencesInformatique.filter(
          (hist) =>
            hist.template_name ==
            this.listTemplates.informatique[this.currentTemplate.informatique]
        ).length ?? 0;

      //Verify if current template is the same than the current evaluation
      const hasCurrent =
        this.competencesInformatique &&
        this.listTemplates.informatique[this.currentTemplate.informatique] ==
          this.competencesInformatique.template_name &&
        Object.keys(this.competencesInformatique).length > 0;

      return evalCount >= 2 || (evalCount > 0 && hasCurrent);
    },

    cantCompareInformatique() {
      return !this.canCompareInformatique;
    },

    canCompareLinguistique() {
      //TRUE if there are 2 evals in history
      //TRUE if there is 1 eval in history and 1 current eval
      //FALSE otherwise

      //count how many history with the same template
      const evalCount =
        this.historyCompetencesLinguistique.filter(
          (hist) =>
            hist.template_name ==
            this.listTemplates.langue[this.currentTemplate.langue]
        ).length ?? 0;

      //Verify if current template is the same than the current evaluation
      const hasCurrent =
        this.competencesLinguistique &&
        this.listTemplates.langue[this.currentTemplate.langue] ==
          this.competencesLinguistique.template_name &&
        Object.keys(this.competencesLinguistique).length > 0;

      return evalCount >= 2 || (evalCount > 0 && hasCurrent);
    },

    cantCompareLinguistique() {
      return !this.canCompareLinguistique;
    },

    allowedCompCleHistories() {
      return this.historyCompetencesCles.filter((hist) => {
        return hist.template_name === this.listTemplates.compcle[this.currentTemplate.compcle]
            && hist.date_fin_eval !== this.cartoCompetencesClesToDisplay.date_fin_eval;
      }).sort((a, b) => {
        return new Date(b.date_fin_eval).getTime() - new Date(a.date_fin_eval).getTime();
      }).filter((hist, index) => {
        return this.$subscribed() ? true : index < 1;
      });
    },

    allowedCompInfoHistories() {
      return this.historyCompetencesInformatique.filter((hist) => {
        return hist.template_name === this.listTemplates.informatique[this.currentTemplate.informatique]
            && hist.date_fin_eval !== this.cartoInformatiqueToDisplay.date_fin_eval;
      }).sort((a, b) => {
        return new Date(b.date_fin_eval).getTime() - new Date(a.date_fin_eval).getTime();
      }).filter((hist, index) => {
        return this.$subscribed() ? true : index < 1;
      });
    },

    allowedLangHistories() {
      let histories = this.historyCompetencesLinguistique || [];
      histories = histories[1] || [];

      return histories.filter((hist) => {
        return hist.template_name === this.listTemplates.langue[this.currentTemplate.langue]
            && hist.date_fin_eval !== this.cartoLangueToDisplay.date_fin_eval;
      }).sort((a, b) => {
        return new Date(b.date_fin_eval).getTime() - new Date(a.date_fin_eval).getTime();
      }).filter((hist, index) => {
        return this.$subscribed() ? true : index < 1;
      });
    }
  },

  directives: {
    ClickOutside,
  },
};
</script>
